import useSiteData from "../../../hooks/useSiteData";
import { Title } from "../../atoms/Title/title";
import Button from "../../atoms/Button";
import RichText from "../../organisms/RichText/richText";

const FinalStep = ({ data, handlePrevStep, handleOnSubmit }) => {
  const siteData = useSiteData();

  return (
    <>
      <Title
        className="FormSelector__title"
        medium
        tag="h1"
        content="Summary"
      />
      <div className="FormSelector__summary">
        <div className="FormSelector__summaryItem">
          <b>Citizenship</b>
          <p>United States</p>
        </div>
        <div className="FormSelector__summaryItem">
          <b>Service selected</b>
          <RichText
            content={data.service}
            siteData={siteData}
          />
        </div>
        <div className="FormSelector__summaryItem">
          <b>Proposed form type</b>
          <RichText
            content={data.formType}
            siteData={siteData}
          />
        </div>
      </div>
      <div className="FormSelector__requirements">
        <div className="FormSelector__requirementsHeader">
          <b>Requirements</b>
          <p>Start now if your previous document:</p>
        </div>
        <div className="FormSelector__requirementsContent">
          <RichText
            content={data.requeriments}
            siteData={siteData}
          />
        </div>
      </div>
      <div className="FormSelector__buttons">
        <Button
          tertiary
          label="Back"
          onClick={handlePrevStep}
        />
        <span
          className="button button-primary FormSelector__button"
          label="Apply Now"
          onClick={handleOnSubmit}
          onKeyDown={handleOnSubmit}
          role="button"
          tabIndex={0}>
          Apply Now
        </span>
      </div>
    </>
  );
};

export default FinalStep;
